import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Libraries
import ReCAPTCHA from 'react-google-recaptcha';
// Formik
import { useFormikContext } from 'formik';
// Elements
import Label from '../elements/Label';
import Error from '../elements/Error';
import useFormDuuf from '../useFormDuuf';
var CaptchaField = function CaptchaField(_ref) {
  var _ref$formik = _ref.formik,
    formik = _ref$formik === void 0 ? {} : _ref$formik,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    fieldId = _ref.fieldId,
    data = _ref.data;
  var _useFormikContext = useFormikContext(),
    handleChange = _useFormikContext.handleChange;
  var _useFormDuuf = useFormDuuf(),
    captchaSiteKey = _useFormDuuf.captchaSiteKey,
    setCaptchaFilled = _useFormDuuf.setCaptchaFilled;
  if (!captchaSiteKey) {
    return null;
  }
  var handleCaptcha = function handleCaptcha(value) {
    handleChange({
      target: {
        name: 'g-recaptcha-response',
        value: value
      }
    });
    setCaptchaFilled(!!value);
  };
  return _jsxs("div", {
    className: "form-duuf-group form-duuf-group-".concat(data.type.toLowerCase()).concat(data.cssClass ? " ".concat(data.cssClass) : ''),
    children: [_jsx(Label, {
      fieldId: fieldId,
      data: data
    }), _jsx(Error, {
      fieldId: fieldId,
      data: data,
      hasError: hasError,
      formik: formik
    }), _jsx(ReCAPTCHA, {
      sitekey: captchaSiteKey,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      onChange: handleCaptcha,
      onExpired: function onExpired() {
        handleCaptcha('');
      },
      onErrored: function onErrored() {
        handleCaptcha('');
      }
    })]
  });
};
export default CaptchaField;